import { OverrideFunc } from '../../../../model/Override'
import { SxHelperStyle } from '../../../../style/styleUtilities'

export const MuiMenu: OverrideFunc<'MuiMenu'> = () => ({
  defaultProps: {
    PaperProps: {
      variant: 'elevation',
      elevation: 1,
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
  },
  styleOverrides: {
    paper: {
      padding: 10,
      width: 'auto',
      overflow: 'inherit',
      borderRadius: '10px',
    },
    list: {
      ...SxHelperStyle.noIndents,
    },
  },
})
